module.exports = __webpack_public_path__ + "img/aeb92e0.png";